import ApiService from "./api.service";

export const DefectSolutionsService = {
    query() {
        return ApiService.query("/defect-solutions/options");
    }
};
